import { CampaignCoverImage, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

export const findById = createFindById('campaignCoverImages');
export const findByIdThrows = createFindByIdThrows('campaignCoverImages');

type GetFulfilledCampaignCoverImages = (state: YammerState) => Record<string, CampaignCoverImage>;
export const getFulfilledCampaignCoverImages: GetFulfilledCampaignCoverImages = (state) =>
  state.campaignCoverImages.fulfilled.byId;
